module.exports = __webpack_public_path__ + "img/Estrellita-Non-select.svg.2fa2d41a.webp";